// extracted by mini-css-extract-plugin
module.exports = {"reactMarkDown":"markdown_reactMarkDown__KKCpx"};